import { Link } from "react-router-dom";
import type { ComicWork } from "@/mocks/comics";

const STATUS_STYLE: Record<string, string> = {
  连载中: "bg-primary-100 text-primary-700",
  已完结: "bg-secondary-100 text-secondary-700",
  不定期更新: "bg-accent-100 text-accent-700",
};

export default function ComicCard({ work }: { work: ComicWork }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col rounded-xl bg-background-100 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-t-xl">
        <img
          src={work.cover}
          alt={`${work.title} 漫画封面`}
          title={`${work.title} 连载漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-700">
          {work.category}
        </span>
        {work.newUpdate && (
          <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
            <i className="ri-flashlight-line" aria-hidden="true" />
            新更
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className={`rounded-full px-2 py-0.5 ${STATUS_STYLE[work.status] || "bg-background-200 text-foreground-600"}`}>
            {work.status}
          </span>
          <span className="flex items-center gap-1 text-accent-700">
            <i className="ri-star-fill text-xs" aria-hidden="true" />
            {work.rating.toFixed(1)}
          </span>
        </div>
        <p className="truncate text-xs text-foreground-500">
          {work.author} · {work.lastChapter}
        </p>
      </div>
    </Link>
  );
}